(() => {
  if (customElements.get('ss-hover-video')) return;
  class HoverVideo extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const card = this.closest('.ss-hover-card');
      const video = this.querySelector('video');
      if (!card || !video) return;
      const eligible = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
      let wanted = false;
      const stop = () => { wanted = false; video.pause(); this.removeAttribute('data-playing'); };
      const play = () => {
        if (!eligible.matches || document.hidden || navigator.connection?.saveData) return;
        wanted = true;
        video.muted = true;
        if (!video.getAttribute('src')) video.src = video.dataset.src;
        video.play().then(() => { if (wanted && eligible.matches && !document.hidden) this.setAttribute('data-playing', ''); else stop(); }).catch(stop);
      };
      const visibility = () => { if (document.hidden) stop(); };
      const observer = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) stop(); });
      observer.observe(card);
      card.addEventListener('mouseenter', play);
      card.addEventListener('mouseleave', stop);
      video.addEventListener('error', stop);
      eligible.addEventListener('change', stop);
      document.addEventListener('visibilitychange', visibility);
      this.cleanup = () => {
        stop(); observer.disconnect();
        card.removeEventListener('mouseenter', play);
        card.removeEventListener('mouseleave', stop);
        video.removeEventListener('error', stop);
        eligible.removeEventListener('change', stop);
        document.removeEventListener('visibilitychange', visibility);
        this.cleanup = null;
      };
    }
    disconnectedCallback() { this.cleanup?.(); }
  }
  customElements.define('ss-hover-video', HoverVideo);
})();
